<template>
    <v-navigation-drawer
      v-if="user !== null"
      class="default-background"
      dark
      width="190px"
      fixed
      :mini-variant.sync="mini"
      id="left-menu"
      permanent
    >
        <v-img
          src="https://hubo-cmaj-prod.s3.eu-west-1.amazonaws.com/images/logo-horizontal-uska-blanc.png"
          class="logo"
        ></v-img>

        <div class="text-center name">{{ user.first_name }} {{ user.last_name }}</div>

        <div class="d-flex mt-3 mr-3 ml-3 justify-content-between">
            <v-tooltip
              slot="append-outer"
              bottom
            >
                <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      to="/configuration"
                    >
                        <v-icon>settings</v-icon>
                    </v-btn>
                </template>
                <span>Configuration</span>
            </v-tooltip>

            <v-tooltip
              slot="append-outer"
              bottom
            >
                <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      href="https://intercom.help/dahub/fr/"
                      target="_blank"
                    >
                        <v-icon>help</v-icon>
                    </v-btn>
                </template>
                <span>Aide</span>
            </v-tooltip>

            <v-tooltip
              slot="append-outer"
              bottom
            >
                <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      @click="logout()"
                    >
                        <v-icon>exit_to_app</v-icon>
                    </v-btn>
                </template>
                <span>Déconnexion</span>
            </v-tooltip>
        </div>

        <v-divider></v-divider>

        <v-list>
            <v-list-item
              link
              to="/home"
            >
                <v-list-item-icon>
                    <v-icon>home</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Accueil</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              to="/campaigns"
            >
                <v-list-item-icon>
                    <v-icon>dashboard</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Campagnes</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              to="/veille/vtc"
              v-if="vtContract"
            >
                <v-list-item-icon>
                    <v-icon>search</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="d-flex justify-content-between">
                        <span>Veille</span>
                        <span class="ml-3 uska-notification" v-if="vtNotificationsCount">
              {{ vtNotificationsCount }}
            </span>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              to="/providers"
            >
                <v-list-item-icon>
                    <v-icon>reorder</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Prestataires</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              to="/entities"
              v-if="account.tis_type.code === 'DAHUB_QUEBEC' && account.id === 252"
            >
                <v-list-item-icon>
                    <v-icon>work_outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Entreprises</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              to="/dashboard-stat"
              v-if="hasDataQualityModule"
            >
                <v-list-item-icon>
                    <v-icon>query_stats</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Statistiques</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              to="/receptive-providers"
              v-if="hasAuraMenu"
            >
                <v-list-item-icon>
                    <v-icon>reorder</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>AURA</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <a :href="apiUrl + '/nova'" target="_blank">
                <v-list-item
                  link
                  class="admin-item-menu"
                  v-if="isGodMod"
                >
                    <v-list-item-icon>
                        <v-icon>supervised_user_circle</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Nova</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </a>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "LeftMenu",
    data() {
        return {
            mini: false,
            publicPath: process.env.BASE_URL,
            apiUrl: process.env.VUE_APP_API_URL,
        }
    },
    methods: {
        async logout() {
            this.$global.loading = true

            await this.$store.dispatch("account/logout")

            this.$global.loading = false

            localStorage.clear()
            this.$router.push("/")
        },

    },
    computed: {
        ...mapState("account", [
            "user",
            "account",
            "vtContract",
            "vtNotificationsCount",
        ]),
        isGodMod() {
            return this.user.role.name === "GOD"
        },
        hasAuraMenu() {
            return [
                "i.tronchet@auvergnerhonealpes-tourisme.com",
                "b.breheret@auvergnerhonealpes-tourisme.com",
                "c.ract@auvergnerhonealpes-tourisme.com",
            ].includes(this.user.email)
        },
        hasDataQualityModule() {
            return this.account.configurations.dataQualityModule
        },
    },
    created() {
        this.$store.dispatch("account/getVTNotificationsCount")
    },
}
</script>
